<script>
import VulnerabilityReportTabs from '../shared/vulnerability_report/vulnerability_report_tabs.vue';
import ReportNotConfiguredGroup from './report_not_configured_group.vue';

export default {
  components: {
    ReportNotConfiguredGroup,
    VulnerabilityReportTabs,
  },
  inject: ['hasProjects'],
};
</script>

<template>
  <report-not-configured-group v-if="!hasProjects" />
  <vulnerability-report-tabs v-else />
</template>
